export default __webpack_public_path__ + "static/media/arrow-circle-right-solid.652fde94.svg";